import Axios from 'axios';

const API_URL =  process.env.API_URL + '/api/v1/';

class JenisNasabah {
  index() {
    return Axios.get(API_URL + 'jenisnasabah-list');
  }

  show(jenisnasabah) {
    return Axios.get(API_URL + `jenisnasabah/${jenisnasabah}`);
  }
}

export default new JenisNasabah();



// WEBPACK FOOTER //
// ./src/api/jenisnasabah.js